export enum TfaMethod {
  EMAIL = "email",
  // TELEGRAM = "telegram",
  AUTHENTICATOR = "authenticator",
  SMS = "sms",
}
